import { IAxiosInstance } from "../../../AbstractApiClient/AbstractApiClient";
import { ISchema } from "../../validation-types/SchemaDefinition";

const URL = `reports/paystub`;
export const postPaystub = (axios: IAxiosInstance) => {
  return async (
    requestBody: ISchema["#/definitions/IPostPaystubRequestBody"]
  ) => {
    const response = await axios.noRetry.post<
      ISchema["#/definitions/IPostPaystubResponseBody"]
    >(URL, requestBody);
    const resData = response.data;

    if (resData.success) {
      return resData.data;
    }

    throw new Error("Something went wrong");
  };
};
